<template>
  <v-dialog
    v-model="show"
    width="auto"
    @click:outside="init()"
    @keydown="$event.key === 'Escape' ? init() : ''"
  >
    <v-card class="log-wrap">
      <p class="tit">
        {{ batch != null ? `메모일괄등록(${batch.length})` : '코인 메모' }}
        <span class="sub" v-if="batch == null">{{ target.name }}</span>
        <v-chip class="float-right"
            label
            link
            depressed
            color="error"
            @click="deleteSelectedMemo()"
            v-if="batch == null"
        >
          선택메모삭제
        </v-chip>
      </p>
      <div v-if="batch != null"></div>
      <div
        class="log"
        v-else-if="data != null && data.length > 0"
      >
        <div
          class="log-row"
          v-for="(row, index) in data.filter(row => row.category === 'referral')"
          :key="index"
        >
          <span class="log-span memo-span d-flex align-center"
           :class="row.category">
          <v-checkbox
            v-model="checked[index]"
          >
          </v-checkbox>
           {{ row.memo }}</span>
          <div class="info-box d-flex">
            <div>
              <p>{{ makeCreatorToFullName(row.creator) }}</p>
              <p class="date">{{ time.makeLocalTime(row.date, 'sec') }}</p>
            </div>
            <div class="d-flex align-center">
              <v-tooltip
                top
                color="#607D8B"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    class="ml-1"
                    v-on="on"
                    v-bind="attrs"
                    :disabled="row.category!=='referral'"
                    @click="delMemo(target, index)"
                  >
                    <v-icon color="#FF8A65" size="18px">mdi-delete-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>삭제</span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div
        class="log"
        v-else
      >
        <p class="log-row"><span>입금내역이 없습니다.</span></p>
      </div>
      <div class="memo-area" :class="batch != null ? '' : 'mt-4'">
        <v-textarea
          :class="memoCategory.value"
          v-model="coinmemo"
          background-color="#f2f2f2"
          :autofocus="true"
          placeholder="입금내역을 입력해주세요."
          dense
          auto-grow
          flat
          hide-details
          :color="memoCategory.color"
          outlined
          solo
          style="font-size: .9rem"
          ref="areaFocus"
        ></v-textarea>

        <div class="d-flex align-center justify-end mt-2">
          <v-btn
            color="primary"
            elevation
            :disabled="coinmemo.trim().length <= 0"
            @click="updateMemo()"
          >
            등록
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import comm from '@/util/comm';
import time from '@/util/time';

export default {
  name: 'DlgCoinMemo',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    target: {
      type: Object,
      required: true,
    },
    func: {
      type: Function,
    },
    batch: {
      type: Array,
      required: false,
    },
  },
  data: () => ({
    comm,
    time,
    coinmemo: '',
    groups: [],
    staffs: [],
    checked: [false],
    categoryCheck: [],
    textColor: '',
    memoCategory: { label: '레퍼럴', value: 'referral', color: 'referral' },
    categoryColor: [
      { label: '레퍼럴', value: 'referral', color: 'referral' },
    ],
  }),
  computed: {
    ...mapGetters({
      userInfo: 'auth/userInfo',
      coinDlg: 'dialog/coinmemo',
    }),
  },
  methods: {
    ...mapMutations({
      progress: 'dialog/progress',
      confirm: 'dialog/confirm',
    }),
    ...mapActions({
      alert: 'dialog/alert',
    }),
    init() {
      this.$emit('update:show', false);
      this.coinmemo = '';
      this.checked = [];
    },
    getDefaultData() {
      this.$socket.emit('groups.list.get', {
        page: 1,
        itemsPerPage: 0,
        sortBy: ['no'],
        sortDesc: [false],
        filters: [],
      }, (resp) => {
        if (resp.result === 'success') {
          this.$socket.emit('users.staffs.list.get', {
            page: 1,
            itemsPerPage: 0,
            sortBy: [],
            sortDesc: [],
            filters: [],
          }, (res) => {
            if (res.result === 'success') {
              this.groups = resp.items.groups;
              this.staffs = [];
              res.items.forEach((r) => {
                const groupName = comm.getGroupFullPath(this.groups, r.groupNo, '그룹없음 ');
                this.staffs.push({
                  id: r.id,
                  fullName: `${groupName}${r.name}`,
                });
              });
            } else {
              this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${res.code})`]);
              console.error(res);
              this.init();
            }
          });
        } else {
          this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
          console.error(resp);
          this.init();
        }
      });
    },
    makeCreatorToFullName(creator) {
      const row = this.staffs.find((r) => r.id === creator);
      return row?.id === undefined ? '시스템' : row.fullName;
    },
    updateMemo() {
      if (this.coinmemo.trim().length > 300) {
        this.alert(['error', '최대 300자까지 등록가능합니다.']);
      } else if (this.batch === null || this.batch === undefined) {
        /* const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/; */
        const reg = /^[0-9]*$/;
        // if (this.memoCategory.value === 'referral' && reg.exec(this.coinmemo) !== null) {
        if (this.memoCategory.value === 'referral' && reg.test(this.coinmemo) === false) {
          this.alert(['error', '레퍼럴의 경우 숫자만 입력 가능합니다.']);
        } else {
          this.progress(true);
          const memos = [...this.data];
          memos.unshift({
            memo: this.coinmemo,
            creator: this.userInfo.id,
            date: time.makeUTCTime(),
            category: this.memoCategory.value,
          });

          this.$socket.emit('users.customer.update', {
            items: [{
              id: this.target.id,
              memo: JSON.stringify(memos),
            }],
          }, (resp) => {
            if (resp.result === 'success') {
              if (this.memoCategory.value === 'referral') {
                this.$socket.emit('users.customer.memo.referral.update', {
                  items: [{
                    id: this.target.id,
                    memo: this.coinmemo,
                    manager: this.userInfo.id,
                  }],
                }, (response) => {
                  if (response.result === 'success') {
                    this.$emit('update:data', memos);
                    this.alert(['success', '메모가 등록되었습니다.']);
                    this.coinmemo = '';
                    this.func();
                    this.progress(false);
                  } else {
                    this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${response.code})`]);
                    console.error(response);
                    this.loading = false;
                  }
                });
              } else {
                this.$emit('update:data', memos);
                this.alert(['success', '메모가 등록되었습니다.']);
                this.coinmemo = '';
                this.func();
                this.progress(false);
              }
            } else {
              this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
              console.error(resp);
              this.progress(false);
            }
          });
        }
      } else {
        /* const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/; */
        const reg = /^[0-9]*$/;
        // if (this.memoCategory.value === 'referral' && reg.exec(this.coinmemo) !== null) {
        if (this.memoCategory.value === 'referral' && reg.test(this.coinmemo) === false) {
          this.alert(['error', '레퍼럴의 경우 숫자만 입력 가능합니다.']);
        } else {
          console.log({
            items: this.batch,
            memo: this.coinmemo,
            category: this.memoCategory.value,
          });
          this.progress(true);
          this.$socket.emit('users.customer.memo.update', {
            items: this.batch,
            memo: this.coinmemo,
            category: this.memoCategory.value,
          }, (resp) => {
            if (resp.result === 'success') {
              if (this.memoCategory.value === 'referral') {
                this.$socket.emit('users.customer.memo.referral.batch.update', {
                  items: this.batch,
                  memo: this.coinmemo,
                  manager: this.userInfo.id,
                }, (response) => {
                  if (response.result === 'success') {
                    this.alert(['success', '메모가 등록되었습니다.']);
                    this.init();
                    this.func();
                    this.progress(false);
                  } else {
                    this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${response.code})`]);
                    console.error(response);
                    this.loading = false;
                  }
                });
              } else {
                this.alert(['success', '메모가 등록되었습니다.']);
                this.init();
                this.func();
                this.progress(false);
              }
            } else {
              this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
              console.error(resp);
              this.progress(false);
            }
          });
        }
      }
    },
    // 레퍼럴 전용 삭제 로직 일반과 레퍼럴 구분
    delMemo(target, index) {
      for (let i = 0; i < this.data.length; i += 1) {
        if (this.data[i].category === 'referral') {
          this.categoryCheck[i] = true;
        } else {
          this.categoryCheck[i] = false;
        }
      }
      let categoryIndex = 0;
      let realIndex = 0;
      let indexNo = index;
      for (let i = 0; i < this.categoryCheck.length; i += 1) {
        if (indexNo === 0 && categoryIndex === 0) {
          if (this.categoryCheck[0] === false) {
            indexNo += 1;
          }
        }
        if (categoryIndex === indexNo) {
          realIndex = i;
        } else if (index === 0) {
          realIndex = this.categoryCheck.indexOf(true);
        }
        if (this.categoryCheck[i] === true) {
          categoryIndex += 1;
        }
      }

      const func = () => {
        this.confirm({ show: false });
        const userId = target.id;
        this.$socket.emit('users.customer.memo.delete', { id: userId, memoSeq: realIndex }, (resp) => {
          if (resp.result === 'success') {
            this.alert(['success', '삭제되었습니다.']);
            // this.init();
            this.getcustomerMemo(target.id);
            this.func();
            this.progress(false);
          } else {
            this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
            console.error(resp);
          }
        });
      };
      this.confirm({
        show: true,
        func,
        msg: `삭제된 메모는 복구할수 없습니다.
          <br/><br/>정말 삭제할까요?`,
        btnText: '삭제',
        color: 'error',
      });
    },
    updateMemoCategory(category) {
      if (this.categoryColor.filter((e) => e.value === category.value)) {
        this.memoCategory = category;
        this.$refs.areaFocus.focus();
      }
    },
    filterCategory(item) {
      const filtered = this.categoryColor.filter((c) => c.value === item);
      return filtered.color;
    },
    getcustomerMemo(id) {
      this.progress(true);
      this.$socket.emit('users.customer.memo.get', { id }, (resp) => {
        if (resp.result === 'success') {
          this.$emit('update:data', resp.items[0].memo);
          this.progress(false);
        } else {
          this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
          console.error(resp);
        }
      });
    },
    deleteSelectedMemo() {
      const userId = this.target.id;
      const memo = [];
      const currentReferral = [];
      for (let i = 0; i < this.data.length; i += 1) {
        if (this.data[i].category === 'referral') {
          this.categoryCheck[i] = true;
          currentReferral.push(i);
        } else {
          this.categoryCheck[i] = false;
        }
      }

      for (let i = 0; i < this.checked.length; i += 1) {
        if (this.checked[i] === true) {
          memo.push(currentReferral[i]);
        }
      }

      this.$socket.emit('users.customer.memo.selectDel', { id: userId, memoArray: memo }, (resp) => {
        if (resp.result === 'success') {
          this.alert(['success', '삭제되었습니다.']);
          this.checked = [];
          // this.init();
          this.getcustomerMemo(this.target.id);
          this.func();
          this.progress(false);
        } else {
          this.alert(['error', `오류가 발생했습니다. 다시 시도해주세요. (${resp.code})`]);
          console.error(resp);
        }
      });
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val === true) this.getDefaultData();
      },
    },
  },
};
</script>

<style scoped lang="scss">
.log-wrap {
  padding: 15px;
  .tit {
    font-size: 1.1rem;
    font-weight: 500;
    padding-bottom: 10px;
    margin: 0;
  }
  .sub {
    font-size: 0.9rem;
    margin-top: -8px;
    margin-left: 4px;
    margin-bottom: 6px;
  }
  .log {
    max-height: 500px;
    /* overflow: auto; */
    overflow-y: auto;
    overflow-x: hidden;
    .log-row {
      background-color: #f2f2f2;
      padding: 10px;
      margin: 0;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-width: 400px;
      & + .log-row {
        margin-top: 4px;
      }
      span {
        font-size: 0.9rem;
        color: #555;
        & + .info-box {
          margin-left: 40px;
        }
      }
      span.log-span {
        color: #262626;
        font-weight: 500;
        &.memo-span {
          white-space: pre-wrap;
          max-width: 400px;
        }
      }
    }
    .info-box {
      p {
        text-align: right;
        font-size: 0.8rem;
        margin: 0;
        color: #222;
        &.date {
          color: #888;
        }
      }
    }
  }
  .memo-area {
    min-width: 400px;
  }
  .leading {
    color: #2196F3 !important;
  }
  .coin {
    color: #6aa33b !important;
  }
  .etc {
    color: #AA6063 !important;
  }
  .referral {
    color: #FF5252 !important;
  }
}
</style>
